// AUTO-GÉNÉRÉ par scripts/gen-pages-lazy.js — NE PAS ÉDITER À LA MAIN.
// Map des imports explicites de pages (remplace l'import dynamique qui créait
// un contexte webpack de ~70 Ko dans le bundle initial).
// Régénérer : node scripts/gen-pages-lazy.js

export const PAGE_IMPORTS = {
  "ActivationInvitation": () => import("./Pages/ActivationInvitation"),
  "Agency/Dashboard": () => import("./Pages/Agency/Dashboard"),
  "Agency/HotLeads": () => import("./Pages/Agency/HotLeads"),
  "Agency/Join": () => import("./Pages/Agency/Join"),
  "Agency/Leads": () => import("./Pages/Agency/Leads"),
  "Agency/MarketplaceSoldServices": () => import("./Pages/Agency/MarketplaceSoldServices"),
  "Agency/Member": () => import("./Pages/Agency/Member"),
  "Agency/Properties": () => import("./Pages/Agency/Properties"),
  "Agency/PropertyDetail": () => import("./Pages/Agency/PropertyDetail"),
  "Agency/Settings": () => import("./Pages/Agency/Settings"),
  "Agency/Team": () => import("./Pages/Agency/Team"),
  "Agency/UserDetail": () => import("./Pages/Agency/UserDetail"),
  "Agency/UserEdit": () => import("./Pages/Agency/UserEdit"),
  "AgencyLanding": () => import("./Pages/AgencyLanding"),
  "AgentAutonome": () => import("./Pages/AgentAutonome"),
  "AgentAutonome/AgentPropertyDetail": () => import("./Pages/AgentAutonome/AgentPropertyDetail"),
  "AgentAutonome/ConfigureAgent": () => import("./Pages/AgentAutonome/ConfigureAgent"),
  "AppAssistant": () => import("./Pages/AppAssistant"),
  "AppHome": () => import("./Pages/AppHome"),
  "AppOnboarding": () => import("./Pages/AppOnboarding"),
  "AssistantCandidat": () => import("./Pages/AssistantCandidat"),
  "AssistantCandidat/AssignCandidate": () => import("./Pages/AssistantCandidat/AssignCandidate"),
  "AssistantCandidat/Config": () => import("./Pages/AssistantCandidat/Config"),
  "AssistantCandidat/Pilot": () => import("./Pages/AssistantCandidat/Pilot"),
  "AssistantDocuments": () => import("./Pages/AssistantDocuments"),
  "AssistantsImmoIA": () => import("./Pages/AssistantsImmoIA"),
  "AssistantsImmoIA/InApp": () => import("./Pages/AssistantsImmoIA/InApp"),
  "AuthPage": () => import("./Pages/AuthPage"),
  "Billing": () => import("./Pages/Billing"),
  "BillingHistory": () => import("./Pages/BillingHistory"),
  "BlogDetail": () => import("./Pages/BlogDetail"),
  "Blogs": () => import("./Pages/Blogs"),
  "Blogs/blogOwnDetail": () => import("./Pages/Blogs/blogOwnDetail"),
  "Blogs/blogOwning": () => import("./Pages/Blogs/blogOwning"),
  "Blogs/forms/getQuoteForm": () => import("./Pages/Blogs/forms/getQuoteForm"),
  "Blogs/forms/hunterForm": () => import("./Pages/Blogs/forms/hunterForm"),
  "Blogs/forms/interestForm": () => import("./Pages/Blogs/forms/interestForm"),
  "Blogs/forms/moveForm": () => import("./Pages/Blogs/forms/moveForm"),
  "Blogs/forms/sellingForm": () => import("./Pages/Blogs/forms/sellingForm"),
  "Blogs/videoOwnDetail": () => import("./Pages/Blogs/videoOwnDetail"),
  "BoiteAOutils": () => import("./Pages/BoiteAOutils"),
  "BoiteAOutils/AcheterAvantDeVendre": () => import("./Pages/BoiteAOutils/AcheterAvantDeVendre"),
  "BoiteAOutils/AcheterOuResterLocataire": () => import("./Pages/BoiteAOutils/AcheterOuResterLocataire"),
  "BoiteAOutils/AnalyserDpe": () => import("./Pages/BoiteAOutils/AnalyserDpe"),
  "BoiteAOutils/Applications": () => import("./Pages/BoiteAOutils/Applications"),
  "BoiteAOutils/BudgetOccupation": () => import("./Pages/BoiteAOutils/BudgetOccupation"),
  "BoiteAOutils/CarteScolaire": () => import("./Pages/BoiteAOutils/CarteScolaire"),
  "BoiteAOutils/CarteScolaire/College": () => import("./Pages/BoiteAOutils/CarteScolaire/College"),
  "BoiteAOutils/Credit": () => import("./Pages/BoiteAOutils/Credit"),
  "BoiteAOutils/Demenagement": () => import("./Pages/BoiteAOutils/Demenagement"),
  "BoiteAOutils/Dpe": () => import("./Pages/BoiteAOutils/Dpe"),
  "BoiteAOutils/Estimateur": () => import("./Pages/BoiteAOutils/Estimateur"),
  "BoiteAOutils/Estimateur/Wizard": () => import("./Pages/BoiteAOutils/Estimateur/Wizard"),
  "BoiteAOutils/EstimateurLoyer": () => import("./Pages/BoiteAOutils/EstimateurLoyer"),
  "BoiteAOutils/EstimateurLoyer/EstimateDetail": () => import("./Pages/BoiteAOutils/EstimateurLoyer/EstimateDetail"),
  "BoiteAOutils/EstimateurLoyer/MesEstimations": () => import("./Pages/BoiteAOutils/EstimateurLoyer/MesEstimations"),
  "BoiteAOutils/EstimateurLoyer/Wizard": () => import("./Pages/BoiteAOutils/EstimateurLoyer/Wizard"),
  "BoiteAOutils/FicheVille": () => import("./Pages/BoiteAOutils/FicheVille"),
  "BoiteAOutils/FicheVille/CityProfile": () => import("./Pages/BoiteAOutils/FicheVille/CityProfile"),
  "BoiteAOutils/Financabilite": () => import("./Pages/BoiteAOutils/Financabilite"),
  "BoiteAOutils/FiscaliteRevente": () => import("./Pages/BoiteAOutils/FiscaliteRevente"),
  "BoiteAOutils/FiscaliteRevente/MesSimulations": () => import("./Pages/BoiteAOutils/FiscaliteRevente/MesSimulations"),
  "BoiteAOutils/FiscaliteRevente/SimulationDetail": () => import("./Pages/BoiteAOutils/FiscaliteRevente/SimulationDetail"),
  "BoiteAOutils/FiscaliteRevente/Wizard": () => import("./Pages/BoiteAOutils/FiscaliteRevente/Wizard"),
  "BoiteAOutils/FraisNotaire": () => import("./Pages/BoiteAOutils/FraisNotaire"),
  "BoiteAOutils/HomeStaging": () => import("./Pages/BoiteAOutils/HomeStaging"),
  "BoiteAOutils/HomeStaging/SimulationResult": () => import("./Pages/BoiteAOutils/HomeStaging/SimulationResult"),
  "ClientDossiers/ProList": () => import("./Pages/ClientDossiers/ProList"),
  "ClientDossiers/ProDetail": () => import("./Pages/ClientDossiers/ProDetail"),
  "ClientDossiers/ClientList": () => import("./Pages/ClientDossiers/ClientList"),
  "ClientDossiers/ClientDetail": () => import("./Pages/ClientDossiers/ClientDetail"),
  "ClientDossiers/Invitation": () => import("./Pages/ClientDossiers/Invitation"),
  "BoiteAOutils/MesSimulations": () => import("./Pages/BoiteAOutils/MesSimulations"),
  "BoiteAOutils/PrixMarche": () => import("./Pages/BoiteAOutils/PrixMarche"),
  "BoiteAOutils/PrixMaximalOffre": () => import("./Pages/BoiteAOutils/PrixMaximalOffre"),
  "BoiteAOutils/Rentabilite": () => import("./Pages/BoiteAOutils/Rentabilite"),
  "BoiteAOutils/Rentabilite/MesSimulations": () => import("./Pages/BoiteAOutils/Rentabilite/MesSimulations"),
  "BoiteAOutils/Rentabilite/SimulationDetail": () => import("./Pages/BoiteAOutils/Rentabilite/SimulationDetail"),
  "BoiteAOutils/Rentabilite/Wizard": () => import("./Pages/BoiteAOutils/Rentabilite/Wizard"),
  "BoiteAOutils/SimulationResult": () => import("./Pages/BoiteAOutils/SimulationResult"),
  "BoiteAOutils/TaxeFonciere": () => import("./Pages/BoiteAOutils/TaxeFonciere"),
  "BoiteAOutils/TaxeHabitation": () => import("./Pages/BoiteAOutils/TaxeHabitation"),
  "BoiteAOutils/Travaux": () => import("./Pages/BoiteAOutils/Travaux"),
  "BuildingPermit": () => import("./Pages/BuildingPermit"),
  "BuildingPermitlist": () => import("./Pages/BuildingPermitlist"),
  "BuyerFile": () => import("./Pages/BuyerFile"),
  "BuyerFile/CreateSynthesis": () => import("./Pages/BuyerFile/CreateSynthesis"),
  "BuyerLanding": () => import("./Pages/BuyerLanding"),
  "CardDetail": () => import("./Pages/CardDetail"),
  "CguCgv": () => import("./Pages/CguCgv"),
  "ChangePassword": () => import("./Pages/ChangePassword"),
  "Chat": () => import("./Pages/Chat"),
  "CoachImmoIA": () => import("./Pages/CoachImmoIA"),
  "CompanyDetails": () => import("./Pages/CompanyDetails"),
  "ContactUs": () => import("./Pages/ContactUs"),
  "Dashboard": () => import("./Pages/Dashboard"),
  "DeleteUser": () => import("./Pages/DeleteUser"),
  "DormantActivation": () => import("./Pages/DormantActivation"),
  "DreamBigger": () => import("./Pages/DreamBigger"),
  "ExperienceApproval": () => import("./Pages/ExperienceApproval"),
  "ExperiencePublic": () => import("./Pages/ExperiencePublic"),
  "FeedbackExperience": () => import("./Pages/FeedbackExperience"),
  "Finalize": () => import("./Pages/Finalize"),
  "FollowedProperty": () => import("./Pages/FollowedProperty"),
  "FollowedPropertyList": () => import("./Pages/FollowedPropertyList"),
  "Fonctionnalites": () => import("./Pages/Fonctionnalites"),
  "Forgotpassword": () => import("./Pages/Forgotpassword"),
  "Help": () => import("./Pages/Help"),
  "Home": () => import("./Pages/Home"),
  "HomeBuyers": () => import("./Pages/HomeBuyers"),
  "HomeSellers": () => import("./Pages/HomeSellers"),
  "Impersonate": () => import("./Pages/Impersonate"),
  "Invite": () => import("./Pages/Invite"),
  "Invite/Accept": () => import("./Pages/Invite/Accept"),
  "Invite/ReferralProgramDetail": () => import("./Pages/Invite/ReferralProgramDetail"),
  "LandingPage/directory": () => import("./Pages/LandingPage/directory"),
  "LandingPage/offmarket": () => import("./Pages/LandingPage/offmarket"),
  "LandingPage/transactionTool": () => import("./Pages/LandingPage/transactionTool"),
  "Marketplace": () => import("./Pages/Marketplace"),
  "Marketplace/Favorites": () => import("./Pages/Marketplace/Favorites"),
  "Marketplace/ServiceDetail": () => import("./Pages/Marketplace/ServiceDetail"),
  "MarketplaceOrders": () => import("./Pages/MarketplaceOrders"),
  "MyAgency": () => import("./Pages/MyAgency"),
  "NotFoundPage": () => import("./Pages/NotFoundPage"),
  "Notifications": () => import("./Pages/Notifications"),
  "OffMarket": () => import("./Pages/OffMarket"),
  "OffersPro": () => import("./Pages/OffersPro"),
  "OffersProAgents": () => import("./Pages/OffersProAgents"),
  "OffersProDecorateurs": () => import("./Pages/OffersProDecorateurs"),
  "OffersProDiagnostiqueurs": () => import("./Pages/OffersProDiagnostiqueurs"),
  "OffersProHunters": () => import("./Pages/OffersProHunters"),
  "OffersProInvestor": () => import("./Pages/OffersProInvestor"),
  "OnDemandAgent": () => import("./Pages/OnDemandAgent"),
  "Onboarding": () => import("./Pages/Onboarding"),
  "Otpverify": () => import("./Pages/Otpverify"),
  "OwnerLanding": () => import("./Pages/OwnerLanding"),
  "PastTransactions": () => import("./Pages/PastTransactions"),
  "PastTransectionList": () => import("./Pages/PastTransectionList"),
  "PeertopeerEstimation": () => import("./Pages/PeertopeerEstimation"),
  "PeertopeerEstimation/alert": () => import("./Pages/PeertopeerEstimation/alert"),
  "PeertopeerEstimation/estimation": () => import("./Pages/PeertopeerEstimation/estimation"),
  "PeertopeerEstimation/experience": () => import("./Pages/PeertopeerEstimation/experience"),
  "PeertopeerEstimation/peertopeer": () => import("./Pages/PeertopeerEstimation/peertopeer"),
  "PeertopeerEstimation/socialEstimation": () => import("./Pages/PeertopeerEstimation/socialEstimation"),
  "PeertopeerEstimation/wallet": () => import("./Pages/PeertopeerEstimation/wallet"),
  "PhoneNumber": () => import("./Pages/PhoneNumber"),
  "Plan": () => import("./Pages/Plan"),
  "Portfolio/Project": () => import("./Pages/Portfolio/Project"),
  "PrivacyPolicy": () => import("./Pages/PrivacyPolicy"),
  "ProConfigurePayments": () => import("./Pages/ProConfigurePayments"),
  "ProLearning": () => import("./Pages/ProLearning"),
  "ProLearning/ArticleNew": () => import("./Pages/ProLearning/ArticleNew"),
  "ProLearning/VideoNew": () => import("./Pages/ProLearning/VideoNew"),
  "ProMarketplace": () => import("./Pages/ProMarketplace"),
  "ProMarketplace/Catalogue": () => import("./Pages/ProMarketplace/Catalogue"),
  "ProMarketplace/CatalogueDetail": () => import("./Pages/ProMarketplace/CatalogueDetail"),
  "ProMarketplace/ServiceEditor": () => import("./Pages/ProMarketplace/ServiceEditor"),
  "ProMarketplace/SoldServices": () => import("./Pages/ProMarketplace/SoldServices"),
  "ProOffers": () => import("./Pages/ProOffers"),
  "ProOffersAgents": () => import("./Pages/ProOffersAgents"),
  "ProOffersDecorateurs": () => import("./Pages/ProOffersDecorateurs"),
  "ProOffersDiagnostiqueurs": () => import("./Pages/ProOffersDiagnostiqueurs"),
  "ProOffersHunters": () => import("./Pages/ProOffersHunters"),
  "ProOffersInvestor": () => import("./Pages/ProOffersInvestor"),
  "ProPayouts": () => import("./Pages/ProPayouts"),
  "ProPortfolio": () => import("./Pages/ProPortfolio"),
  "ProPortfolio/Editor": () => import("./Pages/ProPortfolio/Editor"),
  "ProPortfolio/Preview": () => import("./Pages/ProPortfolio/Preview"),
  "Profile": () => import("./Pages/Profile"),
  "Profile/ManageNotifications": () => import("./Pages/Profile/ManageNotifications"),
  "ProgrammePilote": () => import("./Pages/ProgrammePilote"),
  "Project": () => import("./Pages/Project"),
  "Prolist": () => import("./Pages/Prolist"),
  "Property": () => import("./Pages/Property"),
  "Property/MyProperties": () => import("./Pages/Property/MyProperties"),
  "PropertyDetails": () => import("./Pages/PropertyDetails"),
  "PropertyDetails/Gallery": () => import("./Pages/PropertyDetails/Gallery"),
  "PropertyDetails/PhotoViewer": () => import("./Pages/PropertyDetails/PhotoViewer"),
  "PropertyDetails/RentabilityAnalysis": () => import("./Pages/PropertyDetails/RentabilityAnalysis"),
  "PropertyDetailsSlug": () => import("./Pages/PropertyDetailsSlug"),
  "PropertyProfile": () => import("./Pages/PropertyProfile"),
  "PropertyTimeline": () => import("./Pages/PropertyTimeline"),
  "QRCodeManagement": () => import("./Pages/QRCodeManagement"),
  "RealEstatePros": () => import("./Pages/RealEstatePros"),
  "RealEstateTransactionOwner": () => import("./Pages/RealEstateTransactionOwner"),
  "RealEstateTransactionSearcher": () => import("./Pages/RealEstateTransactionSearcher"),
  "ReferralAdminDashboard": () => import("./Pages/ReferralAdminDashboard"),
  "ReferralCgu": () => import("./Pages/ReferralCgu"),
  "ReferralLanding": () => import("./Pages/ReferralLanding"),
  "RenterFile": () => import("./Pages/RenterFile"),
  "RepereMarketing": () => import("./Pages/RepereMarketing"),
  "ResetEmail": () => import("./Pages/ResetEmail"),
  "ResetNewEmail": () => import("./Pages/ResetNewEmail"),
  "Resetpassword": () => import("./Pages/Resetpassword"),
  "SearchAlert": () => import("./Pages/SearchAlert"),
  "SearchListings/Detail": () => import("./Pages/SearchListings/Detail"),
  "SearchListings/Discover": () => import("./Pages/SearchListings/Discover"),
  "SearchListings/EditSearch": () => import("./Pages/SearchListings/EditSearch"),
  "SearchListings/Mine": () => import("./Pages/SearchListings/Mine"),
  "SearchListings/PublicDetail": () => import("./Pages/SearchListings/PublicDetail"),
  "SearchListings/PublishSearch": () => import("./Pages/SearchListings/PublishSearch"),
  "SellerFile": () => import("./Pages/SellerFile"),
  "SellerLanding": () => import("./Pages/SellerLanding"),
  "ServicesCarte": () => import("./Pages/ServicesCarte"),
  "Settings/ProfilePage": () => import("./Pages/Settings/ProfilePage"),
  "StripeOnboarding/Refresh": () => import("./Pages/StripeOnboarding/Refresh"),
  "StripeOnboarding/Success": () => import("./Pages/StripeOnboarding/Success"),
  "Support": () => import("./Pages/Support"),
  "Transaction": () => import("./Pages/Transaction"),
  "Transaction/Transaction2": () => import("./Pages/Transaction/Transaction2"),
  "Transaction/Transaction3": () => import("./Pages/Transaction/Transaction3"),
  "Transaction/Transaction4": () => import("./Pages/Transaction/Transaction4"),
  "TransactionDashboard": () => import("./Pages/TransactionDashboard"),
  "TransactionHistoryMarketing": () => import("./Pages/TransactionHistoryMarketing"),
  "TransactionTool": () => import("./Pages/TransactionTool"),
  "UpgradePlan": () => import("./Pages/UpgradePlan"),
  "VisitFolderDashboard": () => import("./Pages/VisitFolderDashboard"),
  "VisitFolderDashboard/GeneratePage": () => import("./Pages/VisitFolderDashboard/GeneratePage"),
  "propertySteps/AddEdit": () => import("./Pages/propertySteps/AddEdit"),
  "propertySteps/Edit": () => import("./Pages/propertySteps/Edit"),
  "propertySteps/property1": () => import("./Pages/propertySteps/property1"),
  "propertySteps/property3": () => import("./Pages/propertySteps/property3"),
  "training": () => import("./Pages/training"),
};
